import angular from 'angular';
import {OwnershipAccountsApi} from './ownership-accounts';

export const OwnershipAccountsApiModule = angular.module('buildium.manager.properties.api.ownership.accounts', [])
    .service('OwnershipAccountsApi', OwnershipAccountsApi);
